import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { validateInputExistenece } from "../../App";
import {
  AA_FETCH_REPORT,
  AA_TRANSACTION_STATUS,
  CE_POLL,
  DS_PARSER,
  GET_CUSTOMER_DETAILS,
  PERFIOS_REPORT,
  PERFIOS_TRANSACTION_STATUS,
  TRIGGER_CE,
  UDYAM_DEROG_CHECK,
} from "../../Config";
import loadingGif from "../../assets/svg/EPL_think_svg/LoadingGif.gif";
import SubTitle from "../../components/core/SubTitle";
import Title from "../../components/core/Title";
import ProgressBar from "../../components/navigation/progress_bar/EPL_ProgressBar";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import { encrypt } from "../../utils/crypto";
import poll from "../../utils/poll";
import sendRequest from "../../utils/sendRequest";
import { AfterLoginLayoutWrapper } from "../_styles/EPL_AfterLoginLayoutWrapper_think";
import {
  A8MovedModal,
  CePollingFailedModal,
  PerfiosRetrieveReportsFailedModal,
  PerfiosRetrieveReportsRetryModal,
  PerfiosStatusRetryModal,
} from "../other-pages/Modals/AllModal";
import { ErrorWrapper } from "./_styles/ErrorWrapper";
import moengage from "@moengage/web-sdk";
import * as qs from "query-string";
import { isStageLogin } from "../../shared/validations/StageLogin";
import { encryptedData } from "../../utils";
moengage.initialize({ app_id: "L9SUGRVWTLEJA9UWH2ZEAMHL", cluster: "dc_3" });


function LoadingScreen({
  loadingHeader = "Please Wait",
  warning = "Do not close the app or hit back button.",
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const search_params_aa = qs.parse(location.search);
  console.log("SEARCH PARAM: ", search_params_aa);
  const search_params = {
    application_form_no: sessionStorage.getItem("application_form_no"),
  };
  const [toggleMessage, setToggleMessage] = useState(true);
  const [retrievePerfiosReportFailed, setRetrievePerfiosReportFailed] =
    useState(false);
  const [retrievePerfiosReportRetry, setRetrievePerfiosReportRetry] =
    useState(false);
  const [perfiosStatusCheck, setPerfiosStatusCheck] = useState(false);
  const [cePollingError, setCePollingError] = useState(false);
  const source = location.pathname.split("/")[1];
  const [customerDetails, setCustomerDetails] = useState({
    application_form_number: sessionStorage.getItem("application_form_no"),
    source: source,
  });
  const [internalStage, setInternalStage] = useState();
  const [a8Modal, setA8Modal] = useState(false);

  let triggerPollingCounter = 1
  const trigger_get_customer_polling = async () => {
    var payload = {
      application_form_number: sessionStorage.getItem("application_form_no"),
    };
    try {
      // console.log("getCUstomerDetails TRY BLOCK");
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      let queryParam;
      if (search_params_aa.type === "AA") {
        if (triggerPollingCounter == 1) {
          queryParam = "?poll=True&trigger_task=True&type=AA"
        } else {
          queryParam = "?poll=True"
        }
      } else {
        if (customerDetails.stage === "HUNTER"){
          queryParam = "?poll=True"
        } else {
          if (triggerPollingCounter == 1) {
            queryParam = "?poll=True&trigger_task=True"
          } else {
            queryParam = "?poll=True"
          }
        }
      }
      const response = await sendRequest(
        "/" + source + GET_CUSTOMER_DETAILS + queryParam,
        formData
      );
      // console.log("Response: ", response);
      if (response.response.STAGE === "IPO_START" || response.response.STAGE === "INCOME_REJECT" || response.response.STAGE === "CE_REJECT" || response.response.STAGE === "A8_INCOME_REJECT" || response.response.STAGE === "R1_LINE_OFFER" || response.response.STAGE === "EMAIL_OTP_VERIFICATION" || response.response.STAGE === "UDYAM_DEROG_START" || response.response.STAGE === "BANK_START" || response.response.STAGE === "NSTP_START" || response.response.STAGE === "DOC_UPLOAD" || response.response.STAGE === "VKYC_START") {
        if (response.response.STAGE === "UDYAM_DEROG_START") {
          udyamDerogCheck()
        }
        if (response.response.STAGE === "R1_LINE_OFFER") {
          dsParserCall()
        }
        if(response.response.STAGE === "CE_REJECT"){
          moengage.track_event("loading_screen_bre_reject", {
            journey_name: customerDetails.source,
            is_bre_reject: "Yes",
          })
        }
        var route = getRouteFromLoanStageService({
          source: source,
          stage: response.response.STAGE,
        });
        setCustomerDetails({
          ...customerDetails,
          stage: response.response.STAGE,
        });
      
        // console.log(
        //   "response.response.Data.application_form_number",
        //   sessionStorage.getItem("application_form_no")
        // );
        // sessionStorage.setItem("abcplAuth", "authenticated");
        // setCustomerDetails({
        //   ...customerDetails,
        //   application_form_number: customerDetails.application_form_number,
        //   stage: response.response.Data.stage,
        //   Data: response.response.Data,
        // });
        // setInternalStage(response.response.Data.stage);
        // console.log("InternalStage: ", response.response.Data.stage);
      } else {
        triggerPollingCounter += 1
        if (triggerPollingCounter > 0) {
          setTimeout(() => {
            trigger_get_customer_polling();
          }, search_params_aa.type === "AA" ? 15000 : triggerPollingCounter >= 6 ? 30000 : 10000);
        } else {
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });
          // // console.log("stage: ", customerDetails.stage);
          // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }
      }
    } catch (error) {
      console.error(`Unknown Error: Constants Not Retireved - ${error}`);
    }
    
  }
  useEffect(async () => {
    isStageLogin(     
      customerDetails?.Data?.uuid,
      customerDetails?.Data?.mobile,
      customerDetails?.source,
    );

    setTimeout(() => {
      moengage.track_event("Income verification", {
        Income_verification_status: true,
        "journey name": customerDetails.source,
      });
    }, 1000);

    trigger_get_customer_polling();
    // perfiosPolling();
  }, []);

  const udyamDerogCheck = async () => {
    try {
      const formData1 = new FormData();
      const employmentCheckPayLoad = {
        application_form_no: customerDetails?.application_form_number,
      };
      formData1.append("data", encryptedData(employmentCheckPayLoad,customerDetails.source));
      const response = await sendRequest(
        "/" + customerDetails.source + UDYAM_DEROG_CHECK,
        formData1
      );

      trigger_get_customer_polling();
    } catch (error) {
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      navigate(`${route}`, {
        replace: true,
      });
      return false;
    }
  };

  const dsParserCall = async () => {
    try {
      const formData1 = new FormData();
      const employmentCheckPayLoad = {
        application_form_no: customerDetails?.application_form_number,
      };
      formData1.append("data", encryptedData(employmentCheckPayLoad));
      const response = await sendRequest(
        "/" + customerDetails.source + DS_PARSER,
        formData1
      );
      if (response.response.Success) {
        setCustomerDetails({
          ...customerDetails,
          stage: response.response.STAGE,
        });
      }
    } catch (error) {
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      navigate(`${route}`, {
        replace: true,
      });
      return false;
    }
  };

  useEffect(async () => {
    // console.log("In useEffect of internalStage");
    if (internalStage === "PERFIOS_START") {
      setTimeout(async () => {
        await perfiosPolling();
      }, 12000);
    } else if (internalStage === "CE_START") {
      await callCE();
    } else if (internalStage === "CE_INCOMPLETE") {
      await cePolling();
    }
    // else if (internalStage === "AA_START") {
    //   await aaPolling();
    // }
  }, [internalStage]);

  useEffect(() => {
    const Timeout = setTimeout(() => {
      setToggleMessage(!toggleMessage);
    }, 10000);
    return () => clearTimeout(Timeout);
  }, [toggleMessage]);

  useEffect(async () => {
    // console.log("USEEFFECT-customerDetails-1: Rerouting");
    // if(validateInputExistenece(customerDetails) && validateInputExistenece(customerDetails["stage"])) {
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails.full_name)
    ) {
      // // console.log("\tLoanIPO customerDetails: ", customerDetails);
      // TODO: Handle Staging if needed
    }
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails["stage"])
    ) {
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: customerDetails.stage,
      });
      // // console.log("\tstage: ", customerDetails.stage);
      // // console.log("\troute: ", route);
      if (customerDetails?.Data?.isError === "True") {
        console.log(">>>><<<<<<<<<<");
        if (parseInt(customerDetails?.Data?.retry_count) > 0) {
          // if (customerDetails?.Data?.api_name === "trigger_ce") {
          //   console.log(">>>>>>>>>>>>>>>><<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<");
          //   await callCE();
          // }
          if (customerDetails?.Data?.api_name === "ce_polling") {
            await cePolling();
          }
        } else {
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });
          // // console.log("stage: ", customerDetails.stage);
          // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }
      } else {
        navigate(`${route}`, {
          replace: true,
          state: {
            customerDetails: customerDetails,
          },
        });
      }
    } else {
      // // console.log("\tLoanIPO Ouch customerDetails ", location);
    }
  }, [customerDetails]);

  const [aaTnxId, setAatnxId] = useState();

  const perfiosPolling = async () => {
    if (search_params_aa.type === "AA") {
      try {
        const formData = new FormData();
        const requestData = {
          application_form_no: sessionStorage.getItem("application_form_no"),
        };
        formData.append("data", encryptedData(requestData));
        // // console.log("callInsertSelfieAPI: inside try block")
        const { response } = await poll(
          async () =>
            await sendRequest("/" + source + AA_TRANSACTION_STATUS, {
              application_form_no: sessionStorage.getItem(
                "application_form_no"
              ),
            }),
          ({ response }) => response.Success,
          12000,
          5
        );
        // console.log(response);
        if (response.Success) {
          if (response.Message === "Consent Rejected") {
            setCustomerDetails({
              ...customerDetails,

              stage: "PERFIOS_START",
            });
            var route = getRouteFromLoanStageService({
              source: source,
              stage: "PERFIOS_START",
            });
          }
          if (response.status.errorCode === "E_USER_CANCELLED") {
            setTimeout(() => {
              var route = getRouteFromLoanStageService({
                source: source,
                stage: "PERFIOS_START",
              });
              setCustomerDetails({
                ...customerDetails,
                stage: "PERFIOS_START",
              });
            }, 3000);
          }
          if (response.status === "DS_COMPLETED") {
            // console.log("customerDetails", customerDetails);

            await callCE();
            // var route = getRouteFromLoanStageService({
            //   source: source,
            //   stage: response.STAGE,
            // });
            // // // console.log("stage: ", customerDetails.stage);
            // // console.log("route: ", route);
            // navigate(`${route}`, {
            //   replace: true,
            //   state: {
            //     customerDetails: customerDetails,
            //     // customerDetails: "abcd"
            //   },
            // });
          } else if (response.status.status == "COMPLETED") {
            setAatnxId(response.status.perfiosTransactionId);
            // console.log("status.status completed", response.status);
            await aaFetchReport(response.status.perfiosTransactionId);
          } else if (response.status.status.indexOf("ERROR") >= 0) {
            // TODO: show error page
            var route = getRouteFromLoanStageService({
              source: source,
              stage: "error",
            });
            navigate(`${route}`, {
              replace: true,
            });
          }
        }
      } catch (error) {
        // console.log(error);
        var route = getRouteFromLoanStageService({
          source: source,
          stage: "error",
        });
        // console.log("route: ", route);
        navigate(`${route}`, {
          replace: true,
        });
        // console.log("Error: ", error);
      }
    } else {
      try {
        const formData = new FormData();
        const requestData = {
          application_form_no: sessionStorage.getItem("application_form_no"),
        };
        formData.append("data", encryptedData(requestData));
        // // console.log("callInsertSelfieAPI: inside try block")
        const { response } = await poll(
          async () =>
            await sendRequest("/" + source + PERFIOS_TRANSACTION_STATUS, {
              application_form_no: sessionStorage.getItem(
                "application_form_no"
              ),
            }),
          ({ response }) => response.Success,
          12000,
          5
        );
        // console.log(response);
        if (response.Success) {
          if (response.status.errorCode === "E_USER_CANCELLED") {
            moengage.track_event("Income verification", {
              Income_verification_status: false,
              "journey name": customerDetails.source,
            });
            setTimeout(() => {
              var route = getRouteFromLoanStageService({
                source: source,
                stage: "PERFIOS_START",
              });
              setCustomerDetails({
                ...customerDetails,
                stage: "PERFIOS_START",
              });
            }, 3000);
          }
          if (response.status === "DS_COMPLETED") {
            // console.log("customerDetails", customerDetails);

            await callCE();
            // var route = getRouteFromLoanStageService({
            //   source: source,
            //   stage: response.STAGE,
            // });
            // // // console.log("stage: ", customerDetails.stage);
            // // console.log("route: ", route);
            // navigate(`${route}`, {
            //   replace: true,
            //   state: {
            //     customerDetails: customerDetails,
            //     // customerDetails: "abcd"
            //   },
            // });
          } else if (response.status.status == "COMPLETED") {
            // console.log("status.status completed", response.status);
            await generatePerfiosReport();
          } else if (response.status.status.indexOf("ERROR") >= 0) {
            // TODO: show error page
            // var route = getRouteFromLoanStageService({
            //   source: source,
            //   stage: "PERFIOS_START",
            // });
            // navigate(`${route}`, {
            //   replace: true,
            // });
            setPerfiosStatusCheck(true);
          }
        }
      } catch (error) {
        // console.log(error);
        var route = getRouteFromLoanStageService({
          source: source,
          stage: "error",
        });
        // console.log("route: ", route);
        navigate(`${route}`, {
          replace: true,
        });
        // console.log("Error: ", error);
      }
    }
  };

  const cePolling = async () => {
    try {
      const formData = new FormData();
      const requestData = {
        application_form_no: sessionStorage.getItem("application_form_no"),
      };
      formData.append("data", encryptedData(requestData));
      // console.log("callInsertSelfieAPI: inside try block");
      const { response } = await poll(
        async () =>
          await sendRequest("/" + source + CE_POLL, {
            application_form_no: sessionStorage.getItem("application_form_no"),
          }),
        ({ response }) => response.Success
      );
      // console.log(response);
      // console.log(response.STAGE);
      if (response.Success) {
        if (response.Message === "SUCCESS_REJECTED") {
          setCePollingError(true);
        } else {
          // TODO: business logic
          var route = getRouteFromLoanStageService({
            source: source,
            stage: response.STAGE,
          });
          // console.log("route: ", route);
          setCustomerDetails({
            ...customerDetails,
            stage: response.STAGE,
          });
          // console.log("stage: ", customerDetails.stage);
          // navigate(`${route}`, {
          //   replace: true,
          //   state: {
          //     customerDetails: customerDetails,
          //     // customerDetails: "abcd"
          //   },
          // });
        }
      }
    } catch (error) {
      // console.log(error);
      var route = getRouteFromLoanStageService({
        source: source,
        stage: "error",
      });
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
      // console.log("Error: ", error);
    }
  };

  const generatePerfiosReport = async () => {
    // setModal("LOADING");
    try {
      // // console.log("callInsertSelfieAPI: inside try block")
      const formData = new FormData();
      const requestData = {
        application_form_no: sessionStorage.getItem("application_form_no"),
      };
      formData.append("data", encryptedData(requestData));
      // console.log(requestData);
      const response = await sendRequest(
        "/" + source + PERFIOS_REPORT,
        formData
      );
      // console.log(" ", response);
      if (response.response.Success === true) {
        // console.log("customerDetails", customerDetails);
        // console.log("getting cust Details", customerDetails);
        await callCE();
      } else {
        if (response.response.Message === "SUCCESS_REJECTED") {
          setRetrievePerfiosReportFailed(true);
        }
      }
    } catch (error) {
      setRetrievePerfiosReportRetry(true);
      // console.log(error);
      // var route = getRouteFromLoanStageService({
      //   source: source,
      //   stage: "error",
      // });
      // // console.log("route: ", route);
      // navigate(`${route}`, {
      //   replace: true,
      // });
      // console.log("callTartanURL: inside catch block");
    }
  };

  const aaFetchReport = async (trnxId) => {
    // setModal("LOADING");
    try {
      // // console.log("callInsertSelfieAPI: inside try block")
      const formData = new FormData();
      const requestData = {
        application_form_no: sessionStorage.getItem("application_form_no"),
        requestId: trnxId,
      };
      formData.append("data", encryptedData(requestData));
      // console.log(requestData);
      const response = await sendRequest(
        "/" + source + AA_FETCH_REPORT,
        formData
      );
      // console.log(" ", response);
      if (response.response.Success === true) {
        // console.log("customerDetails", customerDetails);
        // console.log("getting cust Details", customerDetails);
        await callCE();
      } else {
        if (response.response.Message === "SUCCESS_REJECTED") {
          setRetrievePerfiosReportFailed(true);
        }
      }
    } catch (error) {
      setRetrievePerfiosReportRetry(true);
      // console.log(error);
      // var route = getRouteFromLoanStageService({
      //   source: source,
      //   stage: "error",
      // });
      // // console.log("route: ", route);
      // navigate(`${route}`, {
      //   replace: true,
      // });
      // console.log("callTartanURL: inside catch block");
    }
  };

  const callCE = async () => {
    // setModal("LOADING");
    try {
      // // console.log("callInsertSelfieAPI: inside try block")
      const formData = new FormData();
      const requestData = {
        application_form_no: sessionStorage.getItem("application_form_no"),
        account_id: sessionStorage.getItem("application_form_no"),
        product_code: "EPL",
        ce_source: "Epl",
        applicant_type: "Individual",
        kyc_poll_result: "APPROVE",
      };
      formData.append("data", encryptedData(requestData));
      // console.log(requestData);
      const response = await sendRequest("/" + source + TRIGGER_CE, formData);

      // console.log(" ", response);

      if (response.response.Success === true) {
        // console.log("customerDetails", customerDetails);
        // console.log("getting cust Details", customerDetails);
        var route = getRouteFromLoanStageService({
          source: source,
          stage: response.response.STAGE,
        });
        // // console.log("stage: ", customerDetails.stage);
        // console.log("route: ", route);
        // navigate(`${route}`, {
        //   replace: true,
        //   state: {
        //     customerDetails: customerDetails,
        //     // customerDetails: "abcd"
        //   },
        // });
        cePolling();
      }
    } catch (error) {
      // console.log(error);
      var route = getRouteFromLoanStageService({
        source: source,
        stage: "error",
      });
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
      // console.log("callTartanURL: inside catch block");
    }
  };

  return (
    <>
      <ProgressBar showProgress={false} currentStep={0} />
      <A8MovedModal
        isOpen={a8Modal}
        onClose={() => {}}
      />
      <PerfiosStatusRetryModal
        isOpen={perfiosStatusCheck}
        onClose={() => {
          setPerfiosStatusCheck(false);
          var route = getRouteFromLoanStageService({
            source: source,
            stage: "PERFIOS_START",
          });
          navigate(`${route}`, {
            replace: true,
          });
        }}
      />
      <PerfiosRetrieveReportsFailedModal
        isOpen={retrievePerfiosReportFailed}
        onClose={() => {
          setRetrievePerfiosReportFailed(false);
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "rejected",
          });
          // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }}
      />
      <PerfiosRetrieveReportsRetryModal
        isOpen={retrievePerfiosReportRetry}
        onClose={() => {
          setRetrievePerfiosReportRetry(false);
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });
          // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }}
      />
      <CePollingFailedModal
        isOpen={cePollingError}
        onClose={() => {
          setCePollingError(false);
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "rejected",
          });
          // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }}
      />
      <AfterLoginLayoutWrapper>
        <ErrorWrapper className="first-child">
          <Title
            id="pageTitle"
            className="pageTitle"
            text={loadingHeader}
            visible={true}
            clickable={false}
            style={{
              fontSize: "24px",
            }}
          />
          <div
            style={{
              marginTop: "20px",
              textAlign: "center",
            }}
          >
            <SubTitle
              id="pageSubTitle"
              className="pageSubTitle loading"
              text={
                toggleMessage
                  ? "We are fetching your offer details"
                  : "Hold on!, We are almost done"
              }
              style={{
                fontSize: "20px",
              }}
            />
          </div>
          <div className="image">
            <img height={200} width={200} src={loadingGif} alt="Loading" />
          </div>
          <div
            style={{
              marginTop: "20px",
              textAlign: "center",
            }}
          >
            <SubTitle
              id="pageSubTitle"
              className="pageSubTitle"
              text={warning}
              style={{
                fontSize: "20px",
                fontWeight: "700",
              }}
            />
          </div>
        </ErrorWrapper>
      </AfterLoginLayoutWrapper>
    </>
  );
}

export default LoadingScreen;
